import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function AngularJS() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="angular">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-20">
            <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">
              Hire The Best Angular.js Developers
            </h2>
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">
              Hire The Best Angular.js Developers At Dave's Brother Technology
            </h1>
            <p class="lg:w-2/3 mx-auto leading-relaxed text-base">
              Kfrom Dave's Brother Technology and give a push to your startup or business by
              developing cutting edge Angular.js apps. Powering millions of devices
              across the globe, we offer advanced Angular.js application
              development services.
            </p>
          </div>
          <div class="flex flex-col text-center w-full mb-20">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Why Choose Dave's Brother Technology For Angular.js Development?
            </h1>
          </div>
          <div class="flex flex-wrap">
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                24x7 Unwavering Support
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Fretting about loading time issues? Don't worry! Our Angular.js
                developers will be available to resolve any errors and problems
                for you instantaneously.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Flexible Hiring
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Need Angular.js developers for a single project? On Dave's Brother Technology
                Corporation, you can hire a team of developers that will be
                committed to your project until its completion. What's more? You
                can vary your team size according to your needs.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Save Time & Money
              </h2>
              <p class="leading-relaxed text-base mb-4">
                You don't need to break your bank to hire Angular.js developers
                anymore. Dave's Brother Technology smoothens the hiring process for you - It's
                economical and best suited for startups/SMEs.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Customer Is King!
              </h2>
              <p class="leading-relaxed text-base mb-4">
                You are our priority. We are resilient about the service we
                provide and make sure you get to work with the best Angular.js
                developers!
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section class="text-gray-600 body-font">
        <div class="flex flex-col text-center w-full mb-20">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
            Benefits Of Choosing Angular.js For Your Company
          </h1>
        </div>
        <div class="container px-5 py-24 mx-auto flex flex-wrap">
          <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
            <img
              alt="feature"
              class="object-cover object-center mt-20-px h-300 w-300"
              src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"
            />
          </div>
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Round the Clock Support
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                Be assured of round the clock support; our AngularJS developers will address all the issues related to loading times and ensure efficient loading times.
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;Flexible Hiring
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                Don’t want to hire full-time developers!!! No Problem. EC allows you to Hire Dedicated AngularJS Developers team. The assigned team will only work on your project, until it is done. After that, you can relieve them, and can easily alter your team size at any stage.
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Save Time & Money
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                Hiring a dedicated AngularJS developer from Dave's Brother Technology is cost-effective. Our hiring model best suits startups and SMEs.
                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;100% Client Satisfaction
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                Here, client satisfaction is the primary thing. If our client is not satisfied, we too are not satisfied.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
